import * as a from "../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
const p = (t, n, s = 0.6, e = 0.3, o = 1) => {
  const {
    max: m,
    smoothstep: u
  } = a, g = m(m(t.r, t.g), t.b), r = u(
    s,
    // Start of glow
    s + e,
    // End of glow transition
    g
    // Current brightness
  ).mul(o).mul(1);
  return t.add(n.mul(r));
};
export {
  p as glow
};
